import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=40bc3848&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=40bc3848&prod&lang=less&scoped=true"
import style1 from "./ChatRoom.vue?vue&type=style&index=1&id=40bc3848&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc3848",
  null
  
)

export default component.exports